(function(){
  function measureTitle(card){
    var p = card.querySelector('a.contents.user-select-text .text-block p');
    if(!p) return null;
    var range = document.createRange();
    range.selectNodeContents(p);
    var rects = range.getClientRects();
    if(!rects.length) return null;
    var w = 0;
    for(var i=0;i<rects.length;i++) w = Math.max(w, rects[i].width);
    return Math.ceil(w);
  }

  function bind(card){
    var inner = card.querySelector('.product-card__content');
    if(!inner) return;

    // Set dynamic line width via CSS custom property on the text-block
    var tb = card.querySelector('a.contents.user-select-text .text-block');
    if(tb){
      var w = measureTitle(card);
      if(w) tb.style.setProperty('--cv-line-w', w + 'px');
    }

    card.addEventListener('mousemove', function(e){
      var r = card.getBoundingClientRect();
      var py = (e.clientY - r.top) / r.height - 0.5;
      // Always tilt right: rotateY fixed +6deg, rotateX follows mouse vertically
      inner.style.transform = 'perspective(900px) rotateX(' + (-py*4).toFixed(2) + 'deg) rotateY(6deg) translateY(-8px)';
    });
    card.addEventListener('mouseleave', function(){ inner.style.transform=''; });
  }

  function init(){
    document.querySelectorAll('product-card.product-card').forEach(bind);
  }

  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('page:loaded', init);
  document.addEventListener('collection:reloaded', init);
})();